export const formSettings = {
    form: 'contractor-onboarding-wizard',
    destroyOnUnmount: false,
    keepDirtyOnReinitialize: true,
    enableReinitialize: true,
    forceUnregisterOnUnmount: false
};



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/settings.jsx